import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { AnimatedRectangleFallback } from '../../atoms/animatedFallbacks'
import { If } from '../../atoms/if'
import { PaginationDots } from '../../atoms/paginationDots'
import { Text, Title } from '../../atoms/text'
import { StyledSlidesWrapper, StyledFallbackFakeSlide } from './styles'

const CarouselFallback = (props) => {
  const { slides, index, length } = props

  const chosenSlide = useMemo(() => {
    if (slides?.length === 0) return null
    const slideWithH1 = slides.find((slide) => slide.header_tag === 'h1')
    return slideWithH1 || slides[0]
  }, [])

  return (
    <StyledFallbackFakeSlide>
      <StyledSlidesWrapper>
        <AnimatedRectangleFallback>
          <If
            condition={chosenSlide}
            render={() => (
              <>
                <Title tagType={chosenSlide?.header_tag}>
                  {chosenSlide?.header_text}
                </Title>
                <Text>{chosenSlide?.sub_text}</Text>
              </>
            )}
          />
        </AnimatedRectangleFallback>
      </StyledSlidesWrapper>
      <PaginationDots index={index} length={length} />
    </StyledFallbackFakeSlide>
  )
}

CarouselFallback.defaultProps = {
  slides: [],
}

CarouselFallback.propTypes = {
  index: PropTypes.number,
  length: PropTypes.number,
  slides: PropTypes.arrayOf(PropTypes.object),
}

export { CarouselFallback }
